import React from 'react';
import { Switch } from 'antd';
import { AppstoreAddOutlined, AppstoreOutlined } from '@ant-design/icons';

interface DarkModeSwitchProps {
  isDarkMode: boolean;
  toggleTheme: () => void;
}

const DarkModeSwitch: React.FC<DarkModeSwitchProps> = ({ isDarkMode, toggleTheme }) => {
  return (
    <Switch
      checked={isDarkMode}
      onChange={toggleTheme}
      checkedChildren={<AppstoreAddOutlined />}
      unCheckedChildren={<AppstoreOutlined />}
      style={{ backgroundColor: isDarkMode ? '#1890ff' : '#f0f0f0' }}
    />
  );
};

export default DarkModeSwitch;
